//@flow
import Accordion from './Accordion'
import AudioButton from './AudioButton'
import CheckGroup from './CheckGroup'
import {
  DragAndDrop,
  DragAndDropGroup,
  DragAndDropHome,
  DragAndDropTarget,
} from './DragAndDrop'
import HotspotGroup from './HotspotGroup'
import Image from './Image'
import Input from './Input'
import Modal from './Modal'
import Panel from './Panel'

export default {
  Accordion,
  AudioButton,
  CheckGroup,
  DragAndDrop,
  DragAndDropGroup,
  DragAndDropHome,
  DragAndDropTarget,
  HotspotGroup,
  Image,
  Input,
  Modal,
  Panel,
}



// WEBPACK FOOTER //
// ./src/components/QuestionElements/index.js